<template>
	<div class="page">
		<div title="talentTemplate" is='headered'></div>
		<div class="public_title1">
			<!--<div>国务院教育部</div>-->
			<div class="public_title">
				<div>青年阶段——</div>
				<div>国务院教育部1+X职业技能等级证书</div>
			</div>
		</div>
		<div class="timeColumn">
			<div class="timeColumn_text">国务院、教育部、国家发改委发布《关于在院校实施“学历证书+若干职业技能等级证书”制度试点方案》简称1+X项目，北京安达思创管理顾问有限公司申报的“青少年劳动教育项目开发与实施” 技能等级证书获得批准通过，成为1+X职教项目教育部指定的培训评价组织。	</div>
			<div class="timeCol_item">
				<div class="timeCol_item_l">2019.4</div>
				<div class="timeCol_item_r">
					<div class="timeCol_item_row">
						<div class="time_icon"></div>
						<div class="time_text"> 教育部、国家发改委《关于在院校实施“学历证书+若干职业技能等级证书”制度试点方案》“1”学历证书；“X”职业技能证书。</div>
					</div>
				</div>
			</div>
			<div class="timeCol_item">
				<div class="timeCol_item_l">2020.3</div>
				<div class="timeCol_item_r">
					<div class="timeCol_item_row">
						<div class="time_icon"></div>
						<div class="time_text">中共中央国务院《关于全面加强新时代大中小学劳动教育的意见》在大中小学开设劳动必修课。</div>
					</div>				
				</div>
			</div>
			<div class="timeCol_item">
				<div class="timeCol_item_l">2020.10</div>
				<div class="timeCol_item_r">
					<div class="timeCol_item_row">
						<div class="time_icon"></div>
						<div class="time_text">北京安达思创管理顾问有限公司，获得批准成为1+X职业技能证书“劳动教育项目开发与实施”的培训评价组织。</div>
					</div>			
				</div>
			</div>
		</div>
		<!--蓝色盒子-->
		<div class="bluBox">国务院教育部1+X培训评价组织北京安达思创</div>
		<div style="margin-bottom: 0px;" class="youngRow">
			<div class="youngItem">
				<div class="title">试点院校：</div>
				<div class="text">师资培训、学生培训、</div>
				<div class="text">证书的评价考核、</div>
				<div class="text">学分银行</div>
			</div>
			<div class="youngItem">
				<div class="title">研究机构：</div>
				<div class="text">完善培训衍生体系、 </div>
				<div class="text">开发培训及评价体系、</div>
				<div class="text">开发劳动课程项目</div>
			</div>
			<div class="youngItem">
				<div class="title">实践基地：</div>
				<div class="text">中小学劳动教育课、</div>
				<div class="text">实践教学基地、</div>
				<div class="text">后勤及场地保障</div>
			</div>
			<div class="youngItem">
				<div class="title">中小学：</div>
				<div class="text">劳动教育必修课、</div>
				<div class="text">课程的项目需求、</div>
				<div class="text">劳动课程的组织实施</div>
			</div>
		</div>
		<div class="youngStage_df">
			<img style="width: 580px;height: 380px;" src="../../assets/stageImg/youngSrageZs.png"/>
			<img style="width: 580px;height: 360px;" src="../../assets/stageImg/youngSrageZs2.png"/>
		</div>
		<div class="h_title">《关于全面加强新时代大中小学劳动教育的意见》</div>
		<div class="h_title2">2020.3.20     中共中央  国务院</div>
		<div class="h_text">一、培养社会主义建设者和接班人对加强劳动教育的新要求：</div>
		<div class="h_text">劳动教育纳入人才培养全过程，贯通大中小学各学段，贯穿家庭、学校、社会各方面；实现知行合一，形成正确的价值观</div>
		<div class="h_text">二、全面构建体现时代特征的劳动教育体系：</div>
		<div class="h_text"> 文化学习之外参加生活劳动、生产劳动和服务性劳动；形成马克思主义劳动观；在大中小学设立劳动教育必修课程；中小学每周不少于1课时；劳模精神、工匠精神专题不少于16学时、本科不少于32学时；将劳动素养纳入学生综合素质评价体系</div>
		<div class="h_text">三、广泛开展劳动教育实践活动：</div>
		<div class="h_text">家庭基础作用、学校主导作用、社会支持作用</div>
		<div class="h_text">四、着力提升劳动教育支撑保障能力：</div>
		<div class="h_text">拓展实践场所、加强人才队伍、健全经费投入、安全保障</div>
		<div class="h_text">五、切实加强劳动教育的组织实施：</div>
		<div style="margin-bottom: 40px;" class="h_text">加强组织领导；强化督导检查、纳入教育督导体系；加强宣传引导、弘扬劳动光荣、营造全社会关心和支持劳动教育的氛围</div>
		<div class="youngRow2">
			<div class="youngItem2">
				<div class="title">安达课堂：</div>
				<div class="text">校内劳动课程实施、师资培训、1+X技能证书、小小项目师、少年发明家</div>
				<div class="text">《青少年劳动教育开发与实施》高教出版社与人教出版社出版，指定教材</div>
			</div>
			<div class="youngItem2">
				<div class="title">安达院校：</div>
				<div class="text">劳动教育试点院校: </div>
				<div class="text">深圳职业技术学院、</div>
				<div class="text">北京电气工程学校、</div>
				<div class="text">北京五中、北大附小</div>
			</div>
			<div class="youngItem2">
				<div class="title">安达基地：</div>
				<div class="text">劳动课程实践基地：</div>
				<div class="text">京林园林、制造业工厂、</div>
				<div class="text">特警学院实训基地、</div>
				<div class="text">猎鹰国防教育基地、</div>
				<div class="text">建筑工程现场</div>
			</div>
			<div class="youngItem2">
				<div class="title">安达公益：</div>
				<div class="text">中国教育发展战略学会家校协同委员会、</div>
				<div class="text">公益大讲堂、河北、贵州教育帮扶课程、</div>
				<div class="text">中国质量协会青少年分会品牌大赛三等奖</div>
			</div>
		</div>
		<div class="h_title">劳动教育“五步十法”</div>
		<div class="h_title3">1、劳动课程背景：</div>
		<div class="h_text">政策及目标解读、实践基地与劳动课程分类</div>
		<div class="h_title3">2、劳动课程开发：</div>
		<div class="h_text">劳动项目论证与调研、SMART原则可行性评估表</div>
		<div class="h_title3">3、劳动项目计划：</div>
		<div class="h_text">划定项目范围WBS、课程可视化目标SMART、组织团队OBS、责任分配矩阵、时间费用计划、干系人管理责任矩阵、风险防范、资源计划</div>
		<div class="h_title3">4、劳动项目执行：</div>
		<div class="h_text">根据团队矩阵、时间费用计划来执行、干系人管理、团队管理、监督落实</div>
		<div class="h_title3">6、劳动收尾总结：</div>
		<div style="margin-bottom: 120px;" class="h_text">劳动项目全生命周期项目管理执行汇报、团队管理责任监督汇报、SMART原则、质量评价体系、鱼刺图、学生及教师评估打分表</div>
		<div is='footed'></div>
	</div>
</template>

<script>
	import headered from '@/components/header';
	import footed from '@/components/foot';
	export default {
		name: 'index',
		components: {
			headered,
			footed
		},
		data() {
			return {}
		}
	}
</script>

<style scoped="scoped">
	.public_title1{
		width: 1200px;
		margin: 0 auto;
		margin-top: 60px;
		margin-bottom: 20px;
	}
	/*.public_title1>div:nth-child(1){
		width: 1200px;
		margin: 0 auto;
		margin-top: 90px;
		margin-bottom: 20px;
		line-height: 36px;
		color: #1F2329;
		font-size: 36px;
		font-weight: bold;
		text-align: left;
	}*/
	.public_title {
		width: 1200px;
		margin: 0 auto;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
	}
	.public_title2{
		width: 1200px;
		margin: 0 auto;
		margin-bottom: 20px;
		line-height: 36px;
		color: #1F2329;
		font-size: 24px;
		text-align: left;
		font-weight: bold;
	}
	.public_title div {
		line-height: 48px;
		color: #1F2329;
		font-size: 36px;
		text-align: left;
		font-weight: bold;
	}
	
	.public_title div:nth-child(2) {
		color: #0080FF;
	}
	/*时间线*/
	.timeColumn{
		width: 1200px;
		margin: 0 auto;
		margin-bottom: 40px;
	}
	.timeColumn_text{
		line-height: 24px;
		font-size: 18px;
		text-align: left;
		color: #51565D;
		text-indent: 2em;
		margin-bottom: 20px;
	}
	.timeCol_item{
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: flex-start;
		margin-bottom: 20px;
	}
	.timeCol_item_l{
		padding-left: 22px;
		line-height: 24px;
		font-size: 18px;
		text-align: left;
		color: #51565D;
	}
	.timeCol_item_r{
		width: 920px;
		line-height: 24px;
		font-size: 18px;
		text-align: left;
		color: #51565D;
	}
	.timeCol_item_r .timeCol_item_row{
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: flex-start;
		margin-bottom: 6px;
	}
	.timeCol_item_row .time_icon{
		width: 4px;
		height: 4px;
		margin-right: 8px;
		margin-top: 10px;
		background-color: #0080FF;
	}
	.timeCol_item_row .time_text{
		line-height: 24px;
		font-size: 16px;
		color: #51565D;
	}
	.bluBox{
		width: 1200px;
		margin: 0 auto;
		padding: 40px 0px;
		background-color: #4F9EED;
		margin-bottom: 20px;
		line-height: 48px;
		font-size: 36px;
		color: #fff;
	}
	.youngRow{
		width: 1200px;
		margin: 0 auto;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 40px;
	}
	.youngItem{
		width: 282px;
		min-height: 198px;
		padding: 40px 0px 0px 40px;
		background-color: #E1EEFD;
		text-align: left;
	}
	.youngItem>.title{
		line-height: 24px;
		font-size: 20px;
		color: #1F2329;
		margin-bottom: 20px;
	}
	.youngItem>.text{
		line-height: 24px;
		font-size: 18px;
		color: #51565D;
	}
	
	.youngRow2{
		width: 1200px;
		margin: 0 auto;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 40px;
	}
	.youngItem2{
		width: 282px;
		min-height: 268px;
		padding: 40px;
		background-color: #E1EEFD;
		text-align: left;
	}
	.youngItem2>.title{
		line-height: 24px;
		font-size: 20px;
		color: #1F2329;
		margin-bottom: 20px;
	}
	.youngItem2>.text{
		line-height: 24px;
		font-size: 18px;
		color: #51565D;
	}
	
	
	
	/*3.2.2*/
	.h_title{
		line-height: 48px;
		font-size: 36px;
		font-weight: bold;
		text-align: center;
		margin-bottom: 20px;
	}
	.h_title2{
		line-height: 24px;
		font-size: 16px;
		text-align: end;
		width: 1000px;
		margin: 0 auto;
		margin-bottom: 20px;
	}
	.h_title3{
		line-height: 36px;
		font-size: 22px;
		text-align: left;
		width: 1200px;
		margin: 0 auto;
		margin-bottom: 10px;
		font-weight: bold;
	}
	.h_text{
		line-height: 24px;
		font-size: 16px;
		text-align: left;
		text-indent: 2em;
		width: 1200px;
		margin: 0 auto;
		margin-bottom: 20px;
	}
	
	/*3.2.3*/
	.youngSrageZs{
		width: 1000px;
		margin: 0 auto;
	}
	.youngStage_df{
		width: 1200px;
		margin: 40px auto;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
	}
</style>


// WEBPACK FOOTER //
// src/views/phaseList/youngStage1.vue